import { type FC } from 'react';
import {
  UiButton,
  UiHStack,
  type UiHStackProps,
  UiVStack,
  UiStack,
  uiStyles,
  UiText, UiIconPencilSimple,
} from '@/lib/ui';
import { useDisclosure } from '@chakra-ui/react';
import PrivacyForm from './Form/PrivacyForm';
import { useEventSettingsQuery } from '@/registration/hook/useEventSettingsQuery';
import { useRegisterRoute } from '@/registration/hook/useRegisterRoute';
import QueryContainer from '@/base/QueryContainer/QueryContainer';
import BaseButtonPlainIconEdit from '@/base/Button/PlainIconEdit';
import { PermissionAction, PermissionDomain } from '@/api/constant/adminUserPermission';
import BaseAclContainer from '@/account/component/AclContainer';

export interface PrivacyPolicyProps extends UiHStackProps {}

const PrivacyPolicy: FC<PrivacyPolicyProps> = ({ ...props }) => {
  const { isOpen, onToggle } = useDisclosure();
  const { eventId, tenant } = useRegisterRoute();
  const eventQuery = useEventSettingsQuery(eventId);

  return (
    <QueryContainer query={eventQuery}>
      {(eventSettings) => {
        return (
          <>
            <UiHStack
              justifyContent={'flex-start'}
              alignItems={'stretch'}
              // alignItems={'flex-start'}
              // justifyContent={'flex-start'}
              spacing={8}
              minWidth={'300px'}
              p={6}
              bgColor={'#fff'}
              {...props}
            // borderRadius={uiStyles.borderRadius}
            >
              <UiStack spacing={0} alignItems={'stretch'} justifyContent={'space-between'} flexGrow={1}>
                <UiText variant={'body1'} fontWeight={600}>Privacy policy url</UiText>
                <UiText variant={'body2'} color={eventSettings.privacy?.privacyPolicyUrl ? 'text.secondary' : 'red.500'}>{eventSettings.privacy?.privacyPolicyUrl ?? 'Not provided'}</UiText>
              </UiStack>
              <BaseAclContainer tenantId={tenant?.id ?? 0} permissionsRequired={[[PermissionDomain.Registration, PermissionAction.Write]]}>
                <BaseButtonPlainIconEdit onClick={onToggle} />
              </BaseAclContainer>
            </UiHStack>
            <PrivacyForm
              isVisible={isOpen}
              onClose={onToggle}
              privacy={eventSettings.privacy}
            />
          </>
        );
      }}
    </QueryContainer>

  );
};

export default PrivacyPolicy;
